var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1463_247)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.40496 6.59545C5.00704 8.19753 6.49163 8.37295 6.92746 8.3892C7.45413 8.40836 7.99163 7.97836 8.22413 7.53795C7.85329 7.10295 7.37038 6.76545 6.84121 6.39961C6.52954 6.71128 6.14538 7.29045 5.63288 7.08295C5.34163 6.96586 4.62246 6.63461 3.99413 6.00586C3.36538 5.37753 3.03454 4.65836 2.91663 4.36753C2.70913 3.85461 3.28996 3.4692 3.60204 3.15711C3.23621 2.61961 2.90454 2.1242 2.47038 1.77211C2.02371 2.00545 1.59121 2.53878 1.61079 3.07253C1.62704 3.50836 1.80246 4.99295 3.40496 6.59545ZM6.89663 9.2217C6.29663 9.19961 4.59621 8.96503 2.81538 7.1842C1.03496 5.40378 0.800376 3.70378 0.777876 3.10336C0.744543 2.18836 1.44538 1.29961 2.25496 0.952529C2.35245 0.910432 2.45921 0.894404 2.56476 0.906019C2.67032 0.917633 2.77104 0.956491 2.85704 1.01878C3.52704 1.50753 3.98913 2.24795 4.38621 2.82795C4.46881 2.94855 4.50666 3.09424 4.49319 3.2398C4.47972 3.38536 4.41579 3.52163 4.31246 3.62503L3.74746 4.19045C3.87871 4.48003 4.14579 4.9792 4.58329 5.4167C5.02079 5.8542 5.51996 6.12128 5.80996 6.25253L6.37454 5.68753C6.47834 5.58398 6.61518 5.52014 6.76122 5.50712C6.90725 5.4941 7.05323 5.53273 7.17371 5.61628C7.76538 6.02628 8.46038 6.4817 8.96704 7.13045C9.03439 7.21707 9.07723 7.3202 9.09108 7.42905C9.10493 7.53789 9.08929 7.64846 9.04579 7.7492C8.69704 8.56295 7.81454 9.25545 6.89663 9.2217Z",
    fill: "#A53DFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1463_247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.00a1773c383a529d00b5735567d90c28.svg";
export { ForwardRef as ReactComponent };